// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yST9L5Zbe_ByCTIgiD03 {\n\tfont-size: 0.9em;\n\tcolor: #888;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/general/HomeScreen/dashboards/FleetTimelineDashboard.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,WAAW;AACZ","sourcesContent":[".fleetTimelineLabel {\n\tfont-size: 0.9em;\n\tcolor: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fleetTimelineLabel": "yST9L5Zbe_ByCTIgiD03"
};
export default ___CSS_LOADER_EXPORT___;
